import React from 'react'
import create from 'zustand'
import createContext from 'zustand/context'
import shallow from 'zustand/shallow'

const { Provider, useStore } = createContext()
const NavStoreProvider = function ({ children }) {
  const createStore = () =>
    create((set) => {
      const setCurrentNav = (currentNavProp) => {
        console.log(currentNavProp, 'setCurrentNav')
        set(() => ({ currentNav: currentNavProp }))
      }
      const setTreeInputValue = (treeInputValue) => {
        set(() => ({ treeInputValue }))
      }
      const setIsShowTree = (isShowTree) => {
        set(() => ({ isShowTree }))
      }
      const setIsRefreshTree = (isRefreshTree) => {
        set(() => ({ isRefreshTree }))
      }

      return {
        currentNav: {},
        setCurrentNav,
        treeInputValue: '',
        setTreeInputValue,
        isShowTree: true, // 通过按钮控制是否显示左侧树结构
        setIsShowTree,
        isRefreshTree: true,
        setIsRefreshTree,
      }
    })
  return <Provider createStore={createStore}>{children}</Provider>
}

const useNavStore = (selectors, equalityFn = shallow) =>
  useStore(selectors, equalityFn)

export { NavStoreProvider, useNavStore }
